import React from "react";
import StatusModal, { STATUS } from "../../../../../../components/modal/StatusModal";

// Result of saving an account edit on My Page. Despite the name it shows both
// outcomes: status "success" (teal check) or "error" (red warning).
const ModalSuccessEdit = ({
  text = "",
  handleClose,
  show,
  status = STATUS.SUCCESS,
}) => {
  return <StatusModal show={show} onClose={handleClose} status={status} title={text} />;
};

export default ModalSuccessEdit;
